export const landingStyles = {
	container: {
		margin: 0,
		fontFamily: 'Arial, sans-serif',
		backgroundColor: '#F5F5F5',
		color: '#333',
		minHeight: '100vh',
		display: 'flex',
		flexDirection: 'column' as const,
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '15px 40px',
		background: '#fff',
		boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
	},
	headerLogo: {
		display: 'flex',
		alignItems: 'center',
	},
	headerTitle: {
		color: '#3A8DFF',
		marginLeft: '10px',
		margin: 0,
	},
	nav: {
		display: 'flex',
		gap: '20px',
	},
	navLink: {
		color: '#3A8DFF',
		textDecoration: 'none',
		fontWeight: 'bold',
		cursor: 'pointer',
		':hover': {
			textDecoration: 'underline',
		},
	},
	getHero: (isDesktop: boolean): React.CSSProperties => ({
		display: 'flex',
		flexDirection: isDesktop ? 'row' : 'column',
		alignItems: 'center',
		textAlign: isDesktop ? 'left' : 'center',
		justifyContent: isDesktop ? 'space-between' : 'center',
		padding: isDesktop ? '80px' : '60px 20px',
	}),
	heroContent: {
		maxWidth: '500px',
	},
	heroTitle: {
		fontSize: '2.5rem',
		color: '#333',
		marginBottom: '20px',
		margin: '0 0 20px 0',
	},
	heroText: {
		fontSize: '1.2rem',
		color: '#666',
		marginBottom: '30px',
	},
	getHeroImage: (isDesktop: boolean): React.CSSProperties => ({
		marginTop: isDesktop ? '0' : '40px',
		maxWidth: '550px',
		borderRadius: '15px',
		width: '100%',
		height: 'auto',
	}),
	btnPrimary: {
		background: '#3A8DFF',
		color: '#fff',
		padding: '12px 25px',
		borderRadius: '25px',
		border: 'none',
		fontSize: '1rem',
		cursor: 'pointer',
		fontFamily: 'inherit',
		transition: 'background 0.3s ease',
		':hover': {
			background: '#3277d9',
		},
	},
	getFeatures: (isDesktop: boolean): React.CSSProperties => ({
		display: 'grid',
		gridTemplateColumns: isDesktop ? '1fr 1fr' : '1fr',
		gap: '20px',
		padding: isDesktop ? '60px 80px' : '60px 20px',
		background: '#fff',
	}),
	card: {
		background: '#fff',
		borderRadius: '15px',
		padding: '30px',
		boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
	},
	cardImage: {
		width: '100%',
		borderRadius: '10px',
		marginBottom: '15px',
	},
	cardTitle: {
		color: '#3A8DFF',
		marginBottom: '15px',
		margin: '0 0 15px 0',
	},
	cardText: {
		color: '#555',
		marginBottom: '20px',
	},
	btnOutline: {
		background: 'transparent',
		border: '2px solid #3A8DFF',
		color: '#3A8DFF',
		padding: '10px 20px',
		borderRadius: '20px',
		cursor: 'pointer',
		fontFamily: 'inherit',
		fontSize: '1rem',
		transition: 'all 0.3s ease',
		':hover': {
			background: '#3A8DFF',
			color: '#fff',
		},
	},
	footer: {
		background: '#3A8DFF',
		color: '#fff',
		textAlign: 'center' as const,
		padding: '20px',
		marginTop: 'auto',
	},
};

